import React, { 
    Fragment,
    useState,
    useEffect
} from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { alterModal, clearNextPage } from "../redux/index";
import { landingpageSegments } from '../constants';
import { Loader, ErrorMessageForModals } from "../components-shared/index";
import { sessionStorageHelper, getEnvironment } from "../utils/index";
import Hashids from 'hashids';

const UploadPolicyModal = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const hashids = new Hashids()

    const [isError, setIsError] = useState(false)
    const [isMailError, setIsMailError] = useState(false)
    const queryString = useSelector(state => state.queryStringReducer.queryString)

    useEffect(() => {
        if (queryString) {
            sessionStorage.setItem('intellitechId', landingpageSegments[queryString].intellitechId)
        }
    },[])

    useEffect(() => {
        const checkForServerResponse = () => {

            //For dev server testing
            sessionStorage.setItem('outboundData', JSON.stringify(
                {
                    customerNumber: ''
                }
            ))

            sessionStorageHelper.getSessonStorageData('outboundData', 'customerNumber', location, history, (customerNumber) => {
                // 'error' is returned if the backend has sent a mail with error details and customer data to the service center
                // 'errorcaptcha' is returned if the captcha validation failed
                if (customerNumber === 'error') {
                    setIsMailError(true);
                } else if (customerNumber === 'errorcaptcha') {
                    setIsError(true);
                } else {
                    const phoneNumber = sessionStorageHelper.getSessonStorage('userData').PhoneNumber
                    resolveIntellitechUrl(customerNumber, phoneNumber)
                }
            });
        }

        checkForServerResponse();
    }, [])

    const resolveIntellitechUrl = (customerNumber, phoneNumber) => {
        if (!customerNumber || !phoneNumber) return setIsError(true);

        const segment = getIntellitechId();
        const hashedCustomerNumber = encode(customerNumber);
        const hashedPhoneNUmber = encode(phoneNumber);
        const intellitechDomain = getEnvironment() == 'production' ? `upload.privatsikring.dk` : `upload-dev.privatsikring.dk`;

        const intellitechUrl = `https://${intellitechDomain}/steg-1?psCustomerNumber=${hashedCustomerNumber}&psSegment=${segment}&psPhone=${hashedPhoneNUmber}`

        window.location.replace(intellitechUrl);

        // window.open(intellitechUrl, "_blank")
        // close()
    }

    const close = () => {
        dispatch(alterModal());
        dispatch(clearNextPage());

        const locationSearch = sessionStorage.getItem('locationSearch')
        history.push(locationSearch ? `/${locationSearch}` : '/');
    }

    const encode = (input) => {
        if(input) {
            return hashids.encode(input)
        }  
        return ''
    }

    const getIntellitechId = () => {
        const intellitechId = sessionStorage.getItem('intellitechId');
        
        if (intellitechId) {
            //sessionStorage.removeItem('intellitechId')
            return intellitechId;
        } else {
            setIsError(true);
        }
    }

    return (
        <Fragment>
            { isMailError ? <ErrorMessageForModals 
                            headerText='Noget gik galt' 
                            paragraphText='Vi har et teknisk problem. Dine oplysninger er sendt til en rådgiver, som kontakter dig hurtigst muligt.'
                        />
                : isError ? <ErrorMessageForModals /> 
                : <Loader /> }
        </Fragment>
    )
}

export default UploadPolicyModal;